<template>
  <div class="master-table-type">
    <el-table
      :fit="true"
      :data="result"
      v-show="isShow"
      width="100%">

      <!--  表示順 -->
      <el-table-column
        class-name="col-1"
        v-if="displayMethod != '01'"
        type="index"
        :index="indexMethod"
        prop="dispalyOrder"
        :label="$t('label.system.userSeeting.DisplaySort')" />

      <!-- 表示順btn -->
      <el-table-column
        class-name="col-2"
        v-if="displayMethod != '01'"
        type="index"
        :index="indexMethod"
        label="表示順"
        prop="dispalyOrder">

        <div slot-scope="scope" style="width: 60px; display: flex; justify-content: space-between;">

          <sp-smart-button  class="detailed-but with-100" @click="adjustOrder(scope.row, -1)" v-if="scope.$index != 0"  :disabled="scope.$index === 0">
            <img src="@/assets/icon/up-btn.svg">
          </sp-smart-button>

          <sp-smart-button  class="detailed-but with-100" v-if="scope.$index === 0" :disabled="scope.$index === 0">
            <img src="@/assets/icon/forbid-up-btn.svg">
          </sp-smart-button>
          <sp-smart-button  class="detailed-but with-100" @click="adjustOrder(scope.row, +1)" v-if="scope.$index != result.length-1" :disabled="scope.$index === result.length-1" >
            <img src="@/assets/icon/down-btn.svg">
          </sp-smart-button>

          <sp-smart-button  class="detailed-but with-100" v-if="scope.$index === result.length-1" :disabled="scope.$index === result.length-1">
            <img src="@/assets/icon/forbid-down-btn.svg">
          </sp-smart-button>
        </div>
      </el-table-column>

      <!--  ビル名  -->
      <el-table-column
        class-name="col-3"
        prop="buildingName"
        label="ビル名"
      />

      <!--  フロア名 -->
      <el-table-column
        class-name="col-3"
        prop="floorName"
        label="フロア名"
      />

      <!--  エリア名  -->
      <el-table-column
        class-name="col-2"
        prop="areaName"
        label="エリア名"
      />

      <!--  01：環境可視化ページ名 02/03/04：施設名  -->
      <el-table-column
        class-name="col-2"
        prop="resourceName"
        :label="displayMethod == '01' ? '環境可視化ページ名' : '施設名'"
      />


    </el-table>
  </div>
</template>

<script>

export default {
  name: "CmsPageManagementResultBeautify",
  components: {
  },
  props: {
    result: Array,
    isShow: Boolean,
    displayMethod: String,
  },
  data() {
    return {

    };
  },
  methods: {

    //表示順number方法
    indexMethod(index) {
      this.sortIndex = (index+1);
      return (index+1);
    },

    //表示順の切り替え
    adjustOrder(row, i) {
      const currentIndex = this.result.indexOf(row);
      const index = currentIndex + i;
      if (index >= 0 && index < this.result.length) {
        const tempOrder = JSON.parse(JSON.stringify(this.result[currentIndex].displayOrder));
        this.result[currentIndex].displayOrder = this.result[index].displayOrder;
        this.result[index].displayOrder = tempOrder;
      }
      this.changeTableSort();
    },

    //並べ替え
    changeTableSort() {
      this.result.sort(function (a, b) {
        return a.displayOrder - b.displayOrder
      })
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .detail-button{
  button {
    width: 100%;
  }
}
.label-right {
  position: relative;
  top: 4px;
  right: 10px;
  font-size: 16px;
}
.topthestyle {
  float: right;
  margin-bottom: 30px;
}
::v-deep .Operatingarea {
  .my-button {
    width: 134px;
    height: 40px;
    margin-left: 5px;
  }
}
.ColorChange {
  font-size: 14px;
  margin-left: 20px;
  margin-right: 13px;
  color: #6b6b69 !important;
}
::v-deep .zdyselect {
  width: 120px !important;
  font-size: 15px;
  height: 40px !important;
  border-radius: 10px !important;
  box-shadow: -2px -2px 4px #fff,
    4px 4px 4px #e6e6e1;
  .el-input__inner {
    height: 40px !important;
    border-radius: 10px !important;
    background-color: #f2f2ed !important;
    border: 0;
    color: #525250 !important;
  }
  .el-input__suffix {
    top: 0px;
    .el-input__icon {
      line-height: 25px !important;
      color: #c0c4cc;
    }
  }
}

</style>
